// extracted by mini-css-extract-plugin
export default {"header":"Header_header__C5NMc","logo":"Header_logo__zFPkV"};